import {
    Drawer,
    DrawerProps,
    ScrollArea
} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import config from "../config";
import {ApplicationScreenshotRecordFormProps} from "../types.ts";


export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & Omit<ApplicationScreenshotRecordFormProps, 'handleCancel'>) => {

    const title = record.id
        ? `Edit ${config.titles.singular}`
        : `New ${config.titles.singular}`


    return (
        <Drawer
            transitionProps={{
                transition: "slide-up",
                duration: 750,
                timingFunction: "ease"
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >

            <RecordForm
                record={record}
                handleSubmit={(values) => {
                    handleSubmit(values)
                    onClose();
                }}
                handleCancel={onClose}
            />
        </Drawer>
    )
};
